import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';

class CorrectionSummaryService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getCorrectionSummaryDetails(Id) {
        return this.http.get(`/vd/formBuilder/employee/attendance/correction/${Id}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
CorrectionSummaryService.ɵfac = function CorrectionSummaryService_Factory(t) { return new (t || CorrectionSummaryService)(i0.ɵɵinject(i1.HttpClient)); };
CorrectionSummaryService.ɵprov = i0.ɵɵdefineInjectable({ token: CorrectionSummaryService, factory: CorrectionSummaryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CorrectionSummaryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class CorrectionSummaryComponent {
    constructor(correctionSummaryService) {
        this.correctionSummaryService = correctionSummaryService;
        this.observableSubscription$ = new Subject();
        this.getCorrectionSummaryList = [];
    }
    ngOnInit() {
        this.getCorrectionSummaryDetails();
    }
    getCorrectionSummaryDetails() {
        this.getListId = 'AttendanceDataId' in sessionStorage ? parseInt(sessionStorage.getItem('AttendanceDataId')) : null;
        if (this.getListId) {
            this.correctionSummaryService.getCorrectionSummaryDetails(this.getListId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                this.getCorrectionSummaryList = response.data || null;
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
CorrectionSummaryComponent.ɵfac = function CorrectionSummaryComponent_Factory(t) { return new (t || CorrectionSummaryComponent)(i0.ɵɵdirectiveInject(CorrectionSummaryService)); };
CorrectionSummaryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CorrectionSummaryComponent, selectors: [["correction-summary"]], decls: 27, vars: 5, consts: [[1, "container-fluid", "correction-summary", "p-0", "mt-2", "mb-2", "pb-3"], [1, "row"], [1, "col-2"], [1, "summary_details_heading", "m-0"], [1, "summary_details_content", "mb-4"], [1, "summary_details_content"], [1, "col-3"]], template: function CorrectionSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4, " Emp.Id ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵelementStart(8, "p", 3);
        i0.ɵɵtext(9, " Emp.Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "p", 5);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 2);
        i0.ɵɵelementStart(13, "p", 3);
        i0.ɵɵtext(14, " Date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p", 5);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 6);
        i0.ɵɵelementStart(18, "p", 3);
        i0.ɵɵtext(19, " Reason ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "p", 5);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 6);
        i0.ɵɵelementStart(23, "p", 3);
        i0.ɵɵtext(24, " Session ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "p", 5);
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.employeeId) ? ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.employeeId : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.employeeName) ? ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.employeeName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.attendanceDateStr) ? ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.attendanceDateStr : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.reason) ? ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.reason : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.sessionStr) ? ctx.getCorrectionSummaryList == null ? null : ctx.getCorrectionSummaryList.sessionStr : "--", " ");
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CorrectionSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'correction-summary',
                templateUrl: 'correction-summary.component.html',
                styleUrls: ['correction-summary.component.scss']
            }]
    }], function () { return [{ type: CorrectionSummaryService }]; }, null); })();

class CorrectionSummaryModule {
}
CorrectionSummaryModule.ɵfac = function CorrectionSummaryModule_Factory(t) { return new (t || CorrectionSummaryModule)(); };
CorrectionSummaryModule.ɵmod = i0.ɵɵdefineNgModule({ type: CorrectionSummaryModule });
CorrectionSummaryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CorrectionSummaryModule, { declarations: [CorrectionSummaryComponent], exports: [CorrectionSummaryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CorrectionSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [CorrectionSummaryComponent],
                imports: [],
                exports: [CorrectionSummaryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of correction-summary
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CorrectionSummaryComponent, CorrectionSummaryModule, CorrectionSummaryService };
//# sourceMappingURL=correction-summary.js.map
